export async function listingRequest(endpoint, options = {}) {
    const params = new URLSearchParams();
    if (options.parentPage) {
        params.append('ParentPage', options.parentPage.toString());
    }
    if (options.location) {
        params.append('Location', options.location);
    }
    if (options.pageSize) {
        params.append('PageSize', options.pageSize.toString());
    }
    if (options.from) {
        params.append('From', options.from.toString());
    }
    if (options.query) {
        params.append('q', options.query);
    }
    options.facetsToShow?.forEach((facet) => params.append('FacetsToShow', facet));
    Object.entries(options.facetValues ?? {}).forEach(([key, values]) => {
        values.forEach((value) => params.append(key, value));
    });
    const url = `${endpoint}?${params}`;
    const response = await fetch(url);
    return response.json();
}
